/* eslint-disable  import/no-cycle */
import { getAbility } from '@/auth/utils'
import { Ability } from '@casl/ability'
import { initialAbility } from './config'

const ability = getAbility() || initialAbility

export { getAbility }
export default new Ability(ability)
